import { LinkIcon } from '@heroicons/react/24/outline';
import { isURL } from 'validator';
import BasicModal from '../../../components/modals/BasicModal';
import { ChromeExtensionTip } from '../../../components/ChromeExtensionTip';
import { useUnlimitedContext } from '../contexts/UnlimitedContext';

/**
 * Modal dialog that allows users to paste and attach a URL (webpage or PDF) to their prompt.
 * Reads all state from UnlimitedContext — accepts no props.
 */
export const PasteLinkModal = () => {
  const { attachments } = useUnlimitedContext();
  const { showLinkModal, setShowLinkModal, linkInput, setLinkInput, handleAddLink } = attachments;

  return (
    <BasicModal
      icon={<LinkIcon className='h-6 w-6 text-emerald-600' aria-hidden='true' />}
      title='Paste a Link'
      showModal={showLinkModal}
      setShowModal={setShowLinkModal}
      maxWidth='sm:max-w-md'>
      <div className='mt-4 space-y-4'>
        <input
          type='text'
          value={linkInput}
          onChange={(e) => setLinkInput(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              handleAddLink();
            }
          }}
          placeholder='Paste a link to a webpage or PDF'
          className='w-full rounded-lg border border-gray-300 px-3 py-2.5 text-sm focus:border-emerald-500 focus:ring-emerald-500'
        />
        <button
          onClick={handleAddLink}
          disabled={!isURL(linkInput)}
          className='w-full rounded-lg bg-emerald-600 px-4 py-2.5 text-sm font-medium text-white hover:bg-emerald-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed'>
          Add link
        </button>
        <p className='text-sm text-gray-500 text-center'>
          You can also paste links directly into the input area
        </p>
        <ChromeExtensionTip source='paste_link_modal'>
          works right on any webpage — no pasting links.
        </ChromeExtensionTip>
      </div>
    </BasicModal>
  );
};
